// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2BXCn","alert":"SettungsInbox_alert__3CcBf"};